"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelScheduledTask = cancelScheduledTask;
exports.createGroupScheduledTask = createGroupScheduledTask;
exports.createScheduledTask = createScheduledTask;
exports.deleteScheduledTask = deleteScheduledTask;
exports.queryGroupShelfTaskPage = queryGroupShelfTaskPage;
exports.queryScheduledTaskPage = queryScheduledTaskPage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
/**
 * 创建商品上下架定时任务
 * @param {Object} data - 任务参数
 * @returns {Promise}
 */
function createScheduledTask(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsSchedule/createShelfTask',
    method: 'post',
    data: data
  });
}

/**
 * 分页查询商品上下架定时任务
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
function queryScheduledTaskPage(params) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsSchedule/shelfTaskPage',
    method: 'get',
    params: params
  });
}

/**
 * 取消商品上下架定时任务
 * @param {Number} id - 任务ID
 * @returns {Promise}
 */
function cancelScheduledTask(id) {
  return (0, _requestPIM.default)({
    url: "/xyGoodsSchedule/cancelShelfTask/".concat(id),
    method: 'post'
  });
}

/**
 * 删除商品上下架定时任务
 * @param {Number} id - 任务ID
 * @returns {Promise}
 */
function deleteScheduledTask(id) {
  return (0, _requestPIM.default)({
    url: "/xyGoodsSchedule/deleteShelfTask/".concat(id),
    method: 'delete'
  });
}

/**
 * 创建分组上下架定时任务
 * @param {Object} data - 任务参数
 * @returns {Promise}
 */
function createGroupScheduledTask(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsSchedule/createGroupShelfTask',
    method: 'post',
    data: data
  });
}

/**
 * 分页查询分组上下架定时任务
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
function queryGroupShelfTaskPage(params) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsSchedule/groupShelfTaskPage',
    method: 'get',
    params: params
  });
}